export default __webpack_public_path__ + "static/media/wedding8.b3785b1c.webp";